export const WishlistsReducerInitialState = { wishlistProducts: [] };
